export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq4b-Alerts-SingleUser-Empty.07bdf054.png";